export default {
  groups: {},
  groupsSensors: {},
};
